module.exports = __webpack_public_path__ + "img/robot.4f1ef405.gif";